export default __webpack_public_path__ + "static/media/hamburger.5d5b5420.svg";